import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/** Every dialog showing the clinical time form opens at this size, so it looks the same from any opener. */
export const CLINICAL_TIME_DIALOG_SIZE = { width: '70vw', height: '90vh', panelClass: 'clinical-time-dialog-pane' };

export interface TimeCategory {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-clinical-time-dialog',
  template: ` <app-clinical-time-save-form (closeDialog)="onNoClick()" [data]="data"></app-clinical-time-save-form> `,
  styles: [':host { display: block; height: 100%; }'],
})
export class ClinicalTimeDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ClinicalTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
